import React, {Component} from 'react' // eslint-disable-line no-unused-vars
import {withRouter} from 'react-router-dom'
import {TypeRoute} from "../../constants/consts-prop-types"

class ScrollToTop extends Component {
  static propTypes = {
    currentRoute: TypeRoute
  }

/*
  constructor(props) {
    super(props)

    this.onBackButtonEvent = this.onBackButtonEvent.bind(this)

    this.state = {
      isPopState: false
    }
  }

  componentDidMount() {
    // this prevents the default scrollTo top, if user clicks the browser back-button:
    window.onpopstate = this.onBackButtonEvent
  }
*/

  componentDidUpdate(prevProps) {
    if(this.props.currentRoute.id !== prevProps.currentRoute.id) {
      window.scrollTo(0, 0)
      // console.log("TO TOP!!!")

      /*if(!this.state.isPopState) {
        window.scrollTo(0, 0)
        console.log("TO TOP!!!")
      }
      this.setState({
        isPopState: false
      }, () => {
        console.log("isPopState", this.state.isPopState)
      })
      */
    }
  }

/*
  onBackButtonEvent() {
    this.setState({
      isPopState: true
    }, () => {
      console.log("isPopState", this.state.isPopState)
    })
  }
*/

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)


// WEBPACK FOOTER //
// ./src/components/ScrollToTop/ScrollToTop.js